import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './news.css';
import ReactMarkdown from 'react-markdown';
import { FirebaseContext } from './context';
import { getDownloadURL, ref } from 'firebase/storage';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';

interface NewsProps{
    id?: string,
    image: string;
    alt?: string | undefined;
    date?: string;
    title?: string;
    description?: string
}

export const News = ({
    title = "",
    description = "",
    date = "",
    alt = undefined,
    image,
    id = ""
}: NewsProps) => {
    const { db } = useContext(FirebaseContext);
    const [ likes, setLikes ] = useState(0);
    const [ comments, setComments ] = useState(0);
    // const [ shared, setShared ] = useState(0);
    useEffect(() => {
        if (db) {
            return onSnapshot(collection(db, 'v2-news', id, 'likes'), (snapshot) => setLikes(snapshot.docs.length));
        }
    }, [db, id]);
    useEffect(() => {
        if (db) {
            return onSnapshot(query(collection(db, 'v2-news', id, 'comments'), orderBy('date', 'desc')), (snapshot) => {
                setComments(snapshot.docs.length);
            });
        }
    }, [db, id]);
    // useEffect(() => {
    //     if (db) {
    //         return onSnapshot(collection(db, 'v2-news', id, 'shared'), (snapshot) => {
    //             setShared(snapshot.docs.length);
    //         });
    //     }
    // }, [db, id]);
    const navigate = useNavigate();
    const alternative = alt ? alt : title;
    const realImage = image ? (image.startsWith('http') ? image : `https://firebasestorage.googleapis.com/v0/b/dd-asia.appspot.com/o/${image.replace('/', '%2F')}?alt=media`) : undefined;
    return <div className="news-container transition hover:-translate-y-5 cursor-pointer overflow-hidden" onClick={() => navigate(`/article/${id}`)}>
        <img src={realImage} alt={alternative} className="news-image"/>
        <div className="flex justify-evenly mt-3">
            <div className="flex gap-5">
                <p className="text-lg text-gray-500">{likes}</p>
                <i className="fa-regular fa-heart fa-2x text-[#01487C]"></i>
            </div>
            <div className="flex gap-5">
                <p className="text-lg text-gray-500">{comments}</p>
                <i className="fa-regular fa-comment fa-2x text-[#01487C]"></i>
            </div>
            {/* <div className="flex gap-5">
                <p className="text-lg text-gray-500">{shared}</p>
                <i className="fa-regular fa-share fa-2x text-[#01487C]"></i>
            </div> */}
        </div>
        <p className="text-2xl mt-2">{title}</p>
        <p className="news-date text-gray-500">{date}</p>
        <div className='news-description text-lg h-full'><ReactMarkdown>{description.replaceAll('\\n', ' ').replaceAll('\n', ' ')}</ReactMarkdown></div>
    </div>
}